import type { ReactNode } from 'react';
import { Icon, type IconName } from './icon/index.ts';
import styles from './Badge.module.css';

/**
 * The state chip of design system § 14 — a short status in `label` type.
 *
 * The `label` step is uppercase and tracked, so § 5.2's "never a sentence"
 * applies literally: one or two words. An icon may accompany it, because § 12
 * asks every state to carry shape and text as well as colour.
 */

export type BadgeTone = 'accent' | 'neutral' | 'success' | 'near-miss' | 'info';

interface BadgeProps {
  children: ReactNode;
  tone?: BadgeTone;
  icon?: IconName;
}

export function Badge({ children, tone = 'accent', icon }: BadgeProps) {
  return (
    <span className={`${styles.badge} type-label`} data-tone={tone}>
      {icon ? <Icon name={icon} size={16} /> : null}
      {children}
    </span>
  );
}
